import * as yup from "yup";

import type { Translate } from "@shared/i18n/translationKey";

// Factory del schema de selección de mes/año para generar prefactura por período.
// Recibe los arreglos `months` y `years` calculados por el componente (dependen
// de la fecha actual). Se conservan los validadores originales tal cual.
/** Valores del selector de periodo: el mes como nombre y el año como texto. */
export interface PreInvoiceItemValues {
  month: string;
  year: string;
}

export const buildPreInvoiceItemSchema = ({
  t,
  months,
  years,
}: {
  t: Translate;
  months: string[];
  years: string[];
}) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  /**
   * AMBOS VALIDADORES ESTAN INERTES HOY — se conservan tal cual, no se corrigen aca.
   *
   * yup pasa a `.test()` el valor DEL CAMPO, no el objeto entero. Este corre sobre `month`,
   * asi que `value` es el nombre del mes: `value.year` da undefined, `parseInt(undefined)`
   * da NaN, la comparacion contra currentYear es falsa y siempre retorna true. La rama con
   * `months.indexOf` es inalcanzable.
   *
   * El de abajo corre sobre `year` y sale por `!values.month` en la primera linea.
   *
   * El periodo futuro SI se bloquea, pero en otro lado: `isFutureMonthYear` dentro de
   * `validateMonthAndYear` al enviar. Por eso esto no se nota. Corregirlos haria que el
   * formulario empiece a rechazar entradas que hoy pasan — cambio de comportamiento en
   * facturacion, va en su propio ticket.
   */
  const validateFutureDate = (value: string) => {
    const selectedYear = parseInt((value as unknown as PreInvoiceItemValues).year);
    if (selectedYear === currentYear) {
      const selectedMonthIndex = months.indexOf(value);
      return selectedMonthIndex <= currentMonth;
    }
    return true;
  };

  const validateDateCombination = (values: string) => {
    const asPair = values as unknown as PreInvoiceItemValues;
    if (!asPair.month || !asPair.year) return true;

    const selectedYear = parseInt(asPair.year);
    const selectedMonthIndex = months.indexOf(asPair.month);

    if (selectedYear > currentYear) return false;
    if (selectedYear === currentYear && selectedMonthIndex > currentMonth) return false;

    return true;
  };

  return yup
    .object()
    .shape({
      month: yup
        .string()
        .required(t("isRequired"))
        .oneOf(months, t("isRequired"))
        .test(
          "not-future-date",
          "La fecha seleccionada no puede ser mayor a la actual",
          validateFutureDate
        ),
      year: yup
        .string()
        .required(t("isRequired"))
        .oneOf(years, t("isRequired"))
        .test(
          "validate-date-combination",
          "La fecha seleccionada no puede ser mayor a la actual",
          validateDateCombination
        ),
    })
    .required();
};
